<template functional>
  <div class="mtx-card px-3 py-3" v-bind="data.attrs" :class="[data.staticClass, data.class]">
    <slot />
  </div>
</template>

<script>
export default {
  // TODO: accept alternate HTML tags
}
</script>

<style lang="scss">
.mtx-card {
  border-radius: rem($borderRadius);
  color: $offBlack;
  background: #fff;
}
</style>
